// `/accounts/connect` — Settings-side connect flow page (US-176, US-177,
// US-178, US-179).

import { createRoute, useNavigate } from '@tanstack/react-router';

import { ConnectFlow } from '@/features/accounts/ConnectFlow';

import { Route as AccountsLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => AccountsLayoutRoute,
  path: 'connect',
  component: AccountsConnectRoute,
});

function AccountsConnectRoute() {
  const navigate = useNavigate();
  return (
    <ConnectFlow
      onBack={() => {
        void navigate({ to: '/accounts' });
      }}
      onConnected={() => {
        void navigate({ to: '/accounts' });
      }}
    />
  );
}
